<template>
  <div>
    <component :is="activeBetComponent" :name="specialBetName" :actions="actions" :trigger="trigger" />
    <system-bet v-if="isSystemBet" />
    <future-bet v-if="isFutureBet" />
  </div>
</template>

<script>
import NormalBet from "../bets/NormalBet.vue";
import SystemBet from "../bets/SystemBet.vue";
import RandomBet from "../bets/RandomBet.vue";
import RandomSystemBet from "../bets/RandomSystem.vue";
import FutureBet from "../bets/FutureBet.vue";
import SpecialBet from "../bets/SpecialBet.vue";
import { GatewaySvc } from "../../../services/gateway.service";
import { EventBus } from "../../../utilities/event.bus";
import { BettingSvc } from "../../../services/betting.service";
import { ResultsSvc } from "../../../services/results.service";
import { TicketSvc } from "../../../services/ticket.service";

export default {
  name: "Betting",

  components: {
    SystemBet,
    NormalBet,
    RandomSystemBet,
    RandomBet,
    FutureBet,
    SpecialBet
  },

  data() {
    return {
      activeBetComponent: "normal-bet",
      isSystemBet: false,
      isFutureBet: false,
      bettingSvc: BettingSvc.getBettingSvc(),
      specialBetName: "",
      actions: '',
      trigger: false,
    };
  },

  created() {
    this.createSpecialBets();
    this.setupListeners();
  },

  methods: {
    createSpecialBets() {
      if (sevenConfig.data.config.bets) {
        this.bettingSvc.setSpecialBets(sevenConfig.data.config.bets);
      }
    },

    setActiveComponent(componentName) {
      let name = componentName;
      if (componentName === "system-bet") {
        name = "normal-bet";
        this.isSystemBet = true;
      } else {
        this.isSystemBet = false;
      }

      this.isFutureBet = false;

      this.activeBetComponent = name;
    },

    /**
     * Set key event listeners
     */
    setupListeners: function() {
      window.addEventListener("keydown", event => {
        EventBus.$emit("keydown", event);
      });

      EventBus.$on("Payin.Failed", () => {
        this.setActiveComponent("normal-bet");
        this.bettingSvc.type = "normal";

        EventBus.$emit("Keno.KeyboardEvent", { key: "+" });
      });

      EventBus.$on("keydown", event => {
        const eventKey = event.key.toLowerCase();

        if (eventKey === "+") {
          this.setActiveComponent("normal-bet");
          this.bettingSvc.type = "normal";

          if (!this.bettingSvc.updateBet) {
            this.bettingSvc.clearAll();
          }
        }

        if (event.keyCode == 32) {
          //remove focus when ticket is scanned
          let activeInputs = document
            .getElementById("bet-area")
            .getElementsByTagName("input");
          for (let i = 0; i < activeInputs.length; i++) {
            if (document.activeElement == activeInputs[i]) {
              activeInputs[i].blur();
              break;
            }
          }
        }

        if (eventKey === "q") {
          let resultsSvc = ResultsSvc.getResultsSvc();
          resultsSvc.getResults().then(data => {
            for (let i = 0; i < data.length; i += 1) {
              let arr = [];

              for (let j in data[i].draw) {
                arr.push(data[i].draw[j]);
              }

              data[i].draw = arr;
            }

            resultsSvc.printResults(data);
          });
        }

        if (eventKey.toLowerCase() === "w") {
          this.setActiveComponent("random-system-bet");
          this.bettingSvc.type = "system";
        }

        if (eventKey === "s") {
          let bettingSvc = BettingSvc.getBettingSvc();

          //if max system number is lower than played number of tickets
          if (bettingSvc.maxSystemNumber < bettingSvc.ticket.input.length) {
            GatewaySvc.getGatewaySvc().showDialog({
              message: TranslationSvc.getTranslation('max_system_number', bettingSvc.maxSystemNumber),
              type: 'warning'
            });

            return;
          }

          this.setActiveComponent("system-bet");
          this.bettingSvc.type = "system";
        }

        if (eventKey === "r") {
          this.setActiveComponent("random-bet");
          this.bettingSvc.clearAll();
        }

        if (eventKey === "f") {
          this.isFutureBet = true;
        }

        if (eventKey === "/") {
          this.bettingSvc.clearAll();
          EventBus.$emit("Shop.Clear");
          this.setActiveComponent("normal-bet");

          GatewaySvc.getGatewaySvc().sendMessage("Betslip.Clear", {
            betslipId: "Keno"
          });

          TicketSvc.getTicketSvc().ticket = "";
        }

        /**
         * SPECIAL BET LISTENERS
         */
        const specialBetChars = [
          'u',
          'i',
          'o',
          'p',
          'h',
          'j',
          'k',
          'l',
          'v',
          'b',
          'n',
          'm',
        ];

        const specialBets = this.bettingSvc.specialBets;
        if (specialBetChars.indexOf(eventKey) > -1 && specialBets && specialBets[eventKey].active) {
          this.specialBetName = specialBets[eventKey].name;
          this.trigger = !this.trigger;
          this.actions = specialBets[eventKey].actions;
          this.bettingSvc.type = "special";
          this.bettingSvc.name = this.specialBetName;
          this.bettingSvc.shortcut = eventKey;
          this.bettingSvc.actions = specialBets[eventKey].actions;
          this.bettingSvc.specialBetType = specialBets[eventKey].id;
          this.setActiveComponent("special-bet");
        }

        // emit event to app
        EventBus.$emit("Keno.KeyboardEvent", event);
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// Betting.vue?2c071197